module.exports = __webpack_public_path__ + "img/not-available.125ffd8f.png";